'use client';

import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { ArrowUpIcon } from '@heroicons/react/24/solid';

const SCROLL_THRESHOLD_PX = 128;

const LetterListScrollToTop = () => {
  const [isScrollToTopVisible, setIsScrollToTopVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollHandler = () => {
      const parentContainer = wrapperRef.current?.parentElement;

      if (!parentContainer) {
        setIsScrollToTopVisible(false);
        return;
      }

      const parentBoundingClientRect = parentContainer.getBoundingClientRect();
      setIsScrollToTopVisible(parentBoundingClientRect.top < -SCROLL_THRESHOLD_PX);
    };

    window.addEventListener('scroll', scrollHandler);
    scrollHandler();

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  const scrollToTop = () => {
    const parentContainer = wrapperRef.current?.parentElement;
    if (!parentContainer) return;
    parentContainer.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div ref={wrapperRef} className="pointer-events-none sticky bottom-0 z-[3] w-full">
      <button
        type="button"
        className={clsx(
          'absolute bottom-20 right-0 flex items-center justify-center rounded-full bg-white/20 p-3 transition-all hover:-translate-y-1',
          isScrollToTopVisible ? 'pointer-events-auto opacity-100' : 'opacity-0',
        )}
        aria-label="Torna all'inizio dell'elenco"
        onClick={scrollToTop}
      >
        <ArrowUpIcon className="size-10" />
      </button>
    </div>
  );
};

export default LetterListScrollToTop;
